module.exports = __webpack_public_path__ + "img/eye quantity.7455789f.png";